module.exports = __webpack_public_path__ + "static/media/icon_calendar_gray.535ffe2d.svg";